<template>
  <b-card>
    <b-card-header class="d-flex justify-content-between align-items-center">
      <h4>Items intermédiaires</h4>
      <b-button size="sm" variant="primary" @click="newComment">
        Nouvel item 
      </b-button>
    </b-card-header>

    <b-card-body>
      <b-row>
        <b-col cols="6">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Items</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="c in comments"
                :key="c.id"
                @click="setCurrentComment(c)"
                :class="{ selected: currentComment && c.id === currentComment.id }"
              >
                <td>{{ c.comment_content }}</td>
              </tr>
            </tbody>
          </table>
        </b-col>

        <b-col cols="6" v-if="currentComment">
          <b-form @submit.prevent="saveComment">
            <b-form-group label="Item intermédiaire">
              <b-form-input
                v-model="currentComment.comment_content"
                placeholder="Nom de l’item..."
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Conditions">
              <p class="text-muted mb-2">
                Vous pouvez définir une condition en choisissant un Groupe ou un Item, puis un opérateur. Ensuite, comparez soit avec une valeur numérique, soit avec un autre Groupe ou Item.
                <strong>Mode de comparaison :</strong> choisir si la comparaison porte
                sur le <strong>total</strong> du groupe/item ou sur son
                <strong>pourcentage</strong>.
              </p>

              <table v-if="currentComment.conditions.length" class="table table-bordered">
                <thead>
                  <tr>
                    <th>Groupe/Item</th>
                    <th>Type</th>
                    <th>Opérateur</th>
                    <th>Valeur</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(cond, i) in currentComment.conditions" :key="i">
                    <td>{{ cond.scope }}</td>
                    <td>{{ cond.compareType }}</td>
                    <td>{{ cond.operator }}</td>
                    <td>{{ cond.value }}</td>
                    <td>
                      <b-button size="sm" variant="danger" @click="removeCondition(i)">
                        X
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="d-flex flex-wrap align-items-center gap-2 modern-line">
                <b-form-select v-model="tempCondition.scope" :options="condScopeOptions" class="flex-grow-1">
                  <template #first>
                    <b-form-select-option :value="''" disabled>Groupe/Item</b-form-select-option>
                  </template>
                </b-form-select>

                <b-form-select v-model="tempCondition.compareType" class="flex-grow-1">
                  <b-form-select-option value="total">Total</b-form-select-option>
                  <b-form-select-option value="percentage">Pourcentage</b-form-select-option>
                </b-form-select>

                <b-form-select v-model="tempCondition.operator" :options="condOperators" class="flex-grow-1">
                  <template #first>
                    <b-form-select-option :value="''" disabled>Opérateur</b-form-select-option>
                  </template>
                </b-form-select>

                <b-form-select v-model="tempCondition.valueType" class="flex-grow-1">
                  <b-form-select-option value="number">Valeur</b-form-select-option>
                  <b-form-select-option value="scope">Autre Groupe/Item</b-form-select-option>
                </b-form-select>

                <b-form-input
                  v-if="tempCondition.valueType === 'number'"
                  v-model.number="tempCondition.value"
                  type="number"
                  placeholder="Valeur"
                  class="flex-grow-1"
                ></b-form-input>

                <b-form-select
                  v-if="tempCondition.valueType === 'scope'"
                  v-model="tempCondition.value"
                  :options="condScopeOptions"
                  class="flex-grow-1"
                >
                  <template #first>
                    <b-form-select-option :value="''" disabled>Sélectionner un autre Groupe/Item</b-form-select-option>
                  </template>
                </b-form-select>

                <b-button
                  size="sm"
                  variant="success"
                  @click="addCondition"
                  :disabled="!tempCondition.scope || !tempCondition.operator || !tempCondition.value"
                >
                  + Ajouter
                </b-button>
              </div>
            </b-form-group>

            <div class="mt-3">
              <b-button type="submit" variant="success">Sauvegarder</b-button>
              <b-button variant="danger" @click="deleteComment" v-if="!currentComment.isNew">Supprimer</b-button>
              <b-button variant="secondary" @click="cancelEdit">Annuler</b-button>
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-card-body>

    <b-toast
      id="toast"
      :visible="showToast"
      :title="toastTitle"
      :variant="toastVariant"
      auto-hide-delay="3000"
      solid
      @hidden="showToast = false"
    >
      {{ toastMessage }}
    </b-toast>
  </b-card>
</template>

<script>
import axios from "axios";

export default {
  props: ["testId"],
  data() {
    return {
      comments: [],
      currentComment: null,
      testStructure: null,
      showToast: false,
      toastMessage: "",
      toastVariant: "success",
      toastTitle: "Succès",

      tempCondition: { 
        scope: "", 
        operator: "", 
        valueType: "number", 
        value: null,
        compareType: "total"  
      },

      condOperators: ["=", ">", "<"],
    };
  },

  computed: {
    condScopeOptions() {
      if (!this.testStructure) return [];
      const opts = [];
      this.testStructure.itemGroups.forEach((g) => opts.push(`Groupe: ${g.groupName}`));
      this.testStructure.items.forEach((item) => opts.push(`Item: ${item.name}`));
      return opts;
    },
  },

  mounted() {
    this.fetchTestStructure();
    this.fetchComments();
  },

  methods: {
    fetchTestStructure() {
      axios.get(`/api/tests/${this.testId}`).then((resp) => {
        this.testStructure = resp.data;
      });
    },

    fetchComments() {
      axios.get(`/api/tests/${this.testId}/comments`).then((resp) => {
        this.comments = resp.data;
      });
    },

    newComment() {
      this.currentComment = { comment_content: "", conditions: [], isNew: true };
    },

    setCurrentComment(comment) {
      this.currentComment = { ...comment, isNew: false };
    },

    async addCondition() {
      this.currentComment.conditions.push({ ...this.tempCondition });
      this.tempCondition = { scope: "", operator: "", valueType: "number", value: null, compareType: "total" };
      await this.saveComment();
    },

    removeCondition(index) {
      this.currentComment.conditions.splice(index, 1);
      this.saveComment();
    },

    async saveComment() {
      try {
        if (!this.currentComment.conditions.length) {
          this.showToastMessage("Veuillez ajouter au moins 1 condition.", "danger", "Erreur");
          return;
        }

        if (this.currentComment.isNew) {
          const res = await axios.post(`/api/tests/${this.testId}/comments`, this.currentComment);
          this.currentComment.id = res.data.id;
          this.currentComment.isNew = false;
          this.showToastMessage("Item créé avec succès !");
        } else {
          await axios.put(`/api/comments/${this.currentComment.id}`, this.currentComment);
          this.showToastMessage("Item mis à jour avec succès !");
        }

        this.fetchComments();
      } catch (err) {
        this.showToastMessage("Une erreur est survenue.", "danger", "Erreur");
        console.error(err);
      }
    },

    async deleteComment() {
      try {
        if (!this.currentComment.id) return;
        await axios.delete(`/api/comments/${this.currentComment.id}`);
        this.currentComment = null;
        this.fetchComments();
        this.showToastMessage("Item supprimé avec succès !");
      } catch (err) {
        this.showToastMessage("Erreur lors de la suppression.", "danger", "Erreur");
      }
    },

    cancelEdit() {
      this.currentComment = null;
    },

    showToastMessage(message, variant = "success", title = "Succès") {
      this.toastMessage = message;
      this.toastVariant = variant;
      this.toastTitle = title;
      this.showToast = true;
    },
  },
};
</script>

<style>
.selected {
  background-color: #f0f0f0;
  cursor: pointer;
}
.modern-line .form-control,
.modern-line .custom-select {
  min-width: 120px;
  border-radius: 6px;
}
.modern-line {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
</style>
